const OurProductsData = [
    {
        id: 1,
        title: 'Shampoo Antiforfora',
        img: '/images/landing/products/shampoo_antiforfora.webp',
        description: 'Šampon Antiforfora pomaže u borbi protiv peruti i pruža temeljito čišćenje tjemena.',
    },
    {
        id: 2,
        title: 'Absolute One Leave In',
        img: '/images/landing/products/Absolute-One-Leave-In.webp',
        description: 'Absolute One Leave In nudi njegu bez ispiranja za zdraviju i sjajniju kosu.',
    },
    {
        id: 3,
        title: 'Choggan Lavaggi',
        img: '/images/landing/products/chogan_lavaggi.webp',
        description: 'Choggan Lavaggi je blagi šampon idealan za svakodnevnu upotrebu i hidrataciju kose.',
    },
    {
        id: 4,
        title: 'Choggan Maschera',
        img: '/images/landing/products/chogan_maschera.webp',
        description: 'Choggan Maschera intenzivno hrani kosu i poboljšava njenu elastičnost.',
    },
    {
        id: 5,
        title: 'Choggan Shampoo Neem',
        img: '/images/landing/products/chogan_shampoo_neem.webp',
        description: 'Šampon Neem pruža prirodnu zaštitu i dubinsko čišćenje tjemena.',
    },
    {
        id: 6,
        title: 'Linea Bava de Lumaca',
        img: '/images/landing/products/linea_bava_de_lumaca.webp',
        description: 'Linea Bava de Lumaca koristi ekstrakt puževe sluzi za regeneraciju i jačanje kose.',
    },
    {
        id: 7,
        title: 'Magic Argan Oil',
        img: '/images/landing/products/magic_arganoil.webp',
        description: 'Magic Argan Oil hidrira i revitalizuje kosu zahvaljujući bogatom ulju argana.',
    },
    {
        id: 8,
        title: 'Maquilland Cocco',
        img: '/images/landing/products/maquiandcocco.webp',
        description: 'Maquilland Cocco sadrži kokosovo ulje za prirodni sjaj i hidrataciju kose.',
    },
    {
        id: 9,
        title: 'Rommice And Dattero',
        img: '/images/landing/products/romiceanddattero.webp',
        description: 'Rommice And Dattero nudi hranjive sastojke datulje za zdravu i glatku kosu.',
        
    }
];

export default OurProductsData;
